import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FormMode } from '../../common/form-mode';
import { WorkflowDataInterface } from '../workflow-data.interface';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subject } from 'rxjs';
import { Step } from 'src/app/components/designer/models/step';
import { StepCompletedTriggerData } from 'src/app/components/designer/models/step-complete-trigger-data';
import { ContextualMenuEvent } from '../contextual-menu-event';
import { NeedSteps } from '../need-steps';

@Component({
    selector: 'app-workflow-trigger-step-completed-data',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, FaIconComponent, MatTooltipModule],
    templateUrl: './workflow-trigger-step-completed-data.component.html',
    styleUrl: './workflow-trigger-step-completed-data.component.scss'
})
export class WorkflowTriggerStepCompletedDataComponent implements WorkflowDataInterface, OnInit, NeedSteps {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Données affichées par le composant dynamique.
     */
    public _data: StepCompletedTriggerData;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: string | StepCompletedTriggerData) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as StepCompletedTriggerData;
        }

        this.fillForm();
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): StepCompletedTriggerData {
        this.fillData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Liste des étapes du workflow.
     */
    public _steps: Step[];

    /**
     * Spécifie la Liste des étapes du workflow.
     */
    set steps(value: Step[]) {
        this._steps = value;
        this.fillForm();
    }

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            step: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
        });

        this.fillForm();
    }

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }

    /**
     * Remplit le formulaire avec les données.
     */
    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                this.dataForm.get('step').setValue(this._data.stepId);
            }
        }
    }

    /**
     * Met à jour les données à partir du formulaire.
     */
    private fillData() {
        let updatedData: StepCompletedTriggerData = new StepCompletedTriggerData();
        updatedData.stepId = this.dataForm.get('step').value;

        this._data = updatedData;
    }
}
